(function(){
  'use strict';
  if (window.__cwCartSync) return;
  window.__cwCartSync = true;

  function isCartMutation(u){
    if (!u) return false; u = '' + u;
    return u.indexOf('/cart/add') > -1 || u.indexOf('/cart/change') > -1 || u.indexOf('/cart/update') > -1 || u.indexOf('/cart/clear') > -1;
  }

  function refreshDrawer(){
    try { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh')); } catch(e){}
  }

  // Geef elke mystery-box (1 /cart/add.js call) een uniek _mb_id mee.
  // Zo voegt Shopify twee boxen nooit samen tot 1 regel: ze blijven los in cart en checkout.
  function genBoxId(){
    return 'mb' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }
  function isMbTrue(v){ return v === 'true' || v === true; }
  function tagMysteryBody(body){
    if (typeof body !== 'string' || body.indexOf('_mb') === -1) return body;
    try {
      var data = JSON.parse(body);
      var items = data && data.items;
      if (!items || !items.length) return body;
      var hasMb = false, i;
      for (i = 0; i < items.length; i++){
        var pr = items[i] && items[i].properties;
        if (pr && isMbTrue(pr._mb)) { hasMb = true; break; }
      }
      if (!hasMb) return body;
      var boxId = genBoxId();
      for (i = 0; i < items.length; i++){
        var p = items[i] && items[i].properties;
        if (p && isMbTrue(p._mb) && !p._mb_id) { p._mb_id = boxId; }
      }
      return JSON.stringify(data);
    } catch(e){ return body; }
  }

  if (window.fetch){
    var _f = window.fetch;
    window.fetch = function(){
      var a = arguments;
      try {
        var u0 = (a[0] && a[0].url) ? a[0].url : a[0];
        if (('' + u0).indexOf('/cart/add') > -1 && a[1] && typeof a[1].body === 'string'){
          var nb = tagMysteryBody(a[1].body);
          if (nb !== a[1].body){ a[1] = Object.assign({}, a[1], { body: nb }); }
        }
      } catch(e){}
      var p = _f.apply(this, a);
      try { var u = (a[0] && a[0].url) ? a[0].url : a[0]; if (isCartMutation(u)) p.then(function(){ setTimeout(refreshDrawer, 130); }); } catch(e){}
      return p;
    };
  }

  var _o = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(m, u){
    try { if (isCartMutation(u)) this.addEventListener('load', function(){ setTimeout(refreshDrawer, 130); }); } catch(e){}
    return _o.apply(this, arguments);
  };
  var _s = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function(body){
    try {
      if (this.__cwIsAdd === undefined) this.__cwIsAdd = false;
      if (typeof body === 'string'){ var nb = tagMysteryBody(body); if (nb !== body){ arguments[0] = nb; } }
    } catch(e){}
    return _s.apply(this, arguments);
  };
})();
